import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"

export const resetPasswordApi = createAsyncThunk(
    'auth/reset-password',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.patch(`/auth/reset-password`, data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const resetPasswordSlice = createSlice({
    name: 'reset-password',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(resetPasswordApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(resetPasswordApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(resetPasswordApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const resetPasswordReducer = resetPasswordSlice.reducer